var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.129,
    height: 26.919,
    viewBox: "0 0 27.129 26.919",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1987",
    "data-name": "Trac\\xE9 1987",
    d: "M113.433,285.783h-5.348v-1.247a.684.684,0,0,0-.682-.682h-.292a.684.684,0,0,0-.682.682v1.247H100.97v-1.247a.684.684,0,0,0-.682-.682H100a.684.684,0,0,0-.682.682v1.247H93.7a3.7,3.7,0,0,0-3.7,3.7v17.6a3.7,3.7,0,0,0,3.7,3.7h19.734a3.7,3.7,0,0,0,3.7-3.7v-17.6A3.7,3.7,0,0,0,113.433,285.783ZM93.7,287.556h5.614v.4a.684.684,0,0,0,.682.682h.292a.684.684,0,0,0,.682-.682v-.4h5.459v.4a.684.684,0,0,0,.682.682h.292a.684.684,0,0,0,.682-.682v-.4h5.348a1.926,1.926,0,0,1,1.924,1.924v5.252H91.775V289.48A1.926,1.926,0,0,1,93.7,287.556Zm6.5,14.219v-5.815h7.129v5.815ZM107.327,303v6H100.2v-6Zm-8.356-1.228h-7.2v-5.815h7.2Zm9.584-5.815h6.8v5.815h-6.8Zm-16.78,11.116V303h7.2v6H93.7A1.926,1.926,0,0,1,91.775,307.076ZM113.433,309h-4.878v-6h6.8v4.073A1.926,1.926,0,0,1,113.433,309Z",
    transform: "translate(-90.002 -283.854)",
    fill: "#fff",
    opacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventsIcon);
export default __webpack_public_path__ + "static/media/eventsIcon.67ef6e25159750f00d1e89963a987b34.svg";
export { ForwardRef as ReactComponent };